export const ProjectData = [
    {
        id:1,
        title:"Edify – A tutor finder Android App",
        about:"It acts as a bridge between teachers and students to help students for searching suitable private teachers for home tuition with their desire preferences. Built using Android Studio programming language used in this app is Java and database is Firebase Firestore, Authentication.",
        tags:["Android","Java","Firebase"],
        demo:"https://github.com/animesh-anand-dev/Edify",
        github:"https://github.com/animesh-anand-dev/Edify",
        image:require('../../assets/edify.png').default
    },
    {
        id:2,
        title:"COVID-19 Vaccination",
        about:"Built an android application to find available vaccination slots by pincode. Consume public REST APIs provided by Goverment of India in API Setu. Using Kotlin as language, Volley Library to make API Calls in Android Studio.",
        tags:["Android","Kotlin","Volley API","API Setu"],
        demo:"https://github.com/animesh-anand-dev/COWIN-Vaccination",
        github:"https://github.com/animesh-anand-dev/COWIN-Vaccination",
        image:require('../../assets/covid_vacination.png').default
    }
]